






import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class SwitchlangHeader extends Vue {
  private langs = "en";

  @Watch("$i18n.locale", { immediate: true })
  localeChanged(newVal: any) {
    this.langs = "en" === newVal ? "th" : "en";
  }
  public setlocate() {
    if (this.langs == "en") {
      this.$i18n.locale = "en";
    } else {
      this.$i18n.locale = "th";
    }
  }
}
